import React, { PureComponent } from 'react'
import Autosuggest from 'react-autosuggest'
import TextField from 'material-ui-next/TextField'
import Paper from 'material-ui-next/Paper'
import { MenuItem } from 'material-ui-next/Menu'
import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'
import { withStyles } from 'material-ui-next/styles'
import breakpoints from '../../styles/breakpoints'
import IconButton from 'material-ui-next/IconButton'
import classNames from 'classnames'
import { debounce, truncate } from 'lodash'
import Icon from 'material-ui-next/Icon'

function renderInput(inputProps) {
  const {
    classes,
    autoFocus,
    value,
    label,
    ref,
    onFocus,
    onBlur,
    ...other
  } = inputProps

  return (
    <TextField
      fullWidth
      autoFocus={autoFocus}
      className={classes.textField}
      value={value}
      label={label}
      inputRef={ref}
      onFocus={onFocus}
      onBlur={onBlur}
      InputLabelProps={{
        classes: {
          root: classes.inputlabel,
        },
      }}
      InputProps={{
        classes: {
          inputSingleline: classes.inputlabel,
        },
        ...other,
      }}
    />
  )
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  const label = truncate(suggestion.label, {
    length: 50,
  })
  const matches = match(label, query)
  const parts = parse(label, matches)

  return (
    <MenuItem selected={isHighlighted} component="div" style={{ fontSize: 14 }}>
      <div>
        {parts.map((part, index) => {
          return part.highlight ? (
            <span key={index} style={{ fontWeight: 300 }}>
              {part.text}
            </span>
          ) : (
            <strong key={index} style={{ fontWeight: 500 }}>
              {part.text}
            </strong>
          )
        })}
      </div>
    </MenuItem>
  )
}

function renderSuggestionsContainer(options) {
  const { containerProps, children } = options

  return (
    <Paper {...containerProps} square>
      {children}
    </Paper>
  )
}

function getSuggestionValue(suggestion) {
  return suggestion.label
}

const styles = theme => ({
  container: {
    paddingLeft: 16,
    maxWidth: 220,
    fontSize: 14,
    [`@media (max-width: ${breakpoints.sm})`]: {
      maxWidth: 190,
    },
  },
  inputlabel: {
    fontSize: 14,
  },
  noPaddingLeftContainer: {
    marginTop: 14,
    fontSize: 14,
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 10,
    minWidth: 200,
  },
  suggestionsContainerOpenTop: {
    position: 'absolute',
    zIndex: 10,
    height: 140,
    minWidth: 230,
    top: 80,
    overflowY: 'auto',
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  textField: {
    width: 200,
    [`@media (max-width: ${breakpoints.sm})`]: {
      width: 170,
    },
    [`@media (max-width: ${breakpoints.xs})`]: {
      width: '100%',
    },
  },
  clear: {
    marginTop: 16,
    width: '30px',
    height: 30,
    [`@media (max-width: ${breakpoints.xs})`]: {
      marginTop: 0,
      alignSelf: 'flex-end',
      marginBottom: 8,
    },
  },
  clearIcon: {
    color: theme.swapick.colors.neutral,
    fontSize: '20px',
  },
  formWrapper: {
    display: 'inline-flex',
  },
  w100: {
    width: '100%',
  },
  formDesktop: {
    position: 'relative',
    //zIndex: 8,
    display: 'inline',
    margin: 0,
    padding: 0,
  },
  formMobile: {
    display: 'inline',
    marginBottom: 10,
    padding: 0,
    width: '100%',
  },
  paddingRight: {
    paddingRight: 30,
  },
})

class AutoCompleteFilterControlled extends PureComponent {
  render() {
    const {
      classes,
      placeholder,
      fullWidth = false,
      label,
      onFocus,
      onBlur,
      openToTop = false,
      suggestions,
      value,
    } = this.props

    return (
      <div
        className={classNames(classes.formWrapper, {
          [classes.paddingRight]: value === '',
          [classes.w100]: fullWidth,
        })}>
        <div className={fullWidth ? classes.formMobile : classes.formDesktop}>
          <Autosuggest
            theme={{
              container: fullWidth
                ? classes.noPaddingLeftContainer
                : classes.container,
              suggestionsContainerOpen: openToTop
                ? classes.suggestionsContainerOpenTop
                : classes.suggestionsContainerOpen,
              suggestionsList: classes.suggestionsList,
              suggestion: classes.suggestion,
            }}
            renderInputComponent={renderInput}
            suggestions={suggestions}
            onSuggestionSelected={this.props.onSuggestionSelected}
            onSuggestionsFetchRequested={this.props.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.props.onSuggestionsClearRequested}
            renderSuggestionsContainer={renderSuggestionsContainer}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            focusInputOnSuggestionClick={false}
            inputProps={{
              autoFocus: false,
              classes,
              label: label,
              placeholder: placeholder,
              value: value,
              onChange: this.props.onChange,
              onFocus,
              onBlur,
            }}
          />
        </div>
        {value !== '' && (
          <IconButton
            classes={{
              icon: classes.clearIcon,
              root: classes.clear,
            }}
            onClick={this.props.onReset}
            aria-label="Cerca">
            <Icon>close</Icon>
          </IconButton>
        )}
      </div>
    )
  }
}

const AutoCompleteFilterControlledStyled = withStyles(styles)(
  AutoCompleteFilterControlled
)

class AutoCompleteFilter extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value,
      suggestion: props.value,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.suggestion) {
      this.setState({
        value: nextProps.value,
        suggestion: nextProps.value,
      })
      if (nextProps.value.trim().length > 0) {
        this.props.loadSuggestions(nextProps.value)
      }
    }
  }

  loadSuggestionsDebounced = debounce(this.props.loadSuggestions, 150)

  handleSuggestionsFetchRequested = ({ value }) => {
    const q = value.trim()
    if (q.length > 0) {
      this.loadSuggestionsDebounced(value)
    }
  }

  handleSuggestionsClearRequested = () => {
    this.props.clearSuggestions()
  }

  handleSuggestionSelected = (e, { suggestion }) => {
    e.preventDefault()
    this.setState(
      {
        suggestion: suggestion.label,
      },
      () => {
        this.props.onSuggestionSelected(suggestion.label)
      }
    )
  }

  handleChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    })
  }

  clear = () => {
    this.setState({
      value: '',
      suggestion: '',
    })
  }

  resetValue = () => {
    this.setState(
      {
        value: '',
        suggestion: '',
      },
      () => {
        this.props.onSuggestionSelected('')
      }
    )
  }

  render() {
    return (
      <AutoCompleteFilterControlledStyled
        {...this.props}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        onSuggestionSelected={this.handleSuggestionSelected}
        onReset={this.resetValue}
        value={this.state.value}
        onChange={this.handleChange}
      />
    )
  }
}

export default AutoCompleteFilter



// WEBPACK FOOTER //
// ./src/common/TopBar/AutoCompleteFilter.js